import { LdsService, LpServicesService, MdsService } from '@service';
import { VictaDupeCheckClient } from '@ropto/victa-dupe-check-client';
import { ReferrerEnum, VictaProductEnum } from '@enum';
import { environmentStage, isBrowser, parseUrlParams } from '@src/lib';

// split test
const randomNumber = Math.floor(Math.random() * 3);

if (isBrowser) {
  window.location.href = `${process.env.REDIRECT_URL_ONE}${location.search}`;
}

function dynamicProduct(): string | undefined {
  if (!isBrowser) {
    return;
  }

  const { introducer } = parseUrlParams();

  if (!introducer) {
    return;
  }

  return {
    [ReferrerEnum.ZURU]: '379',
    [ReferrerEnum.WYBE]: '384',
    [ReferrerEnum.TCG]: '393',
    [ReferrerEnum.TCGL]: '394',
    [ReferrerEnum.CLOCKWORK]: '399',
  }[introducer];
}

const integrationApiKey = {
  prod: 'Fc1uH0uFEu49ABnvPZsUn61vNvcfLQ5a9022tA5I',
  dev: 'sX1916xRfQe2V0DyumAI9PRjpkfzwSm3YSvC8Q29',
};

export const ldsService: LdsService = new LdsService({
  baseUrl: process.env.LDS_URL || 'https://r1rqj5sxlc.execute-api.eu-west-1.amazonaws.com',
  opts: { productId: '394', clientId: '94' },
  initHeaders: { 'x-api-key': integrationApiKey[environmentStage()] },
});

export const mdsService: MdsService = new MdsService({
  baseUrl: process.env.MDS_URL || 'https://v7njlb8x7i.execute-api.eu-west-2.amazonaws.com',
  opts: { productId: '333', clientId: '1' },
  storageKey: 'mdsLeadId',
  resumeKeyKey: 'tcglPcpExternalLp011Resume',
});

export const lpServicesService: LpServicesService = new LpServicesService({
  baseUrl: process.env.LP_SERVICES_URL || 'https://1spvcfs52c.execute-api.eu-west-1.amazonaws.com',
  opts: { product: VictaProductEnum.UNDISCLOSED_COMMISSION },
});

export const vdcService = new VictaDupeCheckClient(process.env.VDC_URL || 'https://9kks2axbzh.execute-api.eu-west-1.amazonaws.com/dev/');
